import React from 'react';
import styled from 'styled-components';

const BubbleContainer = styled.div`
  display: flex;
  justify-content: ${props => props.isUser ? 'flex-end' : 'flex-start'};
  margin: 8px 0;
`;

const Bubble = styled.div`
  padding: 12px;
  border-radius: 10px;
  max-width: 70%;
  background-color: ${props => props.isUser ? 'rgba(0, 255, 0, 0.2)' : 'rgba(0, 0, 255, 0.2)'};
`;

const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px);
  padding: 20px;
  overflow-y: auto;
`;

const InputContainer = styled.form`
  display: flex;
  padding: 20px;
  background: white;
  border-top: 1px solid #eee;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
`;

const Input = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-right: 10px;
`;

const SendButton = styled.button`
  padding: 10px 20px;
  background: #FF0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  
  &:hover {
    background: #E6E600;
  }
`;

const ChatBubble = ({ message }) => {
  const isUser = message.sender === 'user';

  return (
    <BubbleContainer isUser={isUser}>
      <Bubble isUser={isUser}>
        {message.content}
      </Bubble>
    </BubbleContainer>
  );
};

function ChatView({ messages, onSendMessage }) {
  const [newMessage, setNewMessage] = React.useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newMessage.trim()) {
      onSendMessage(newMessage);
      setNewMessage('');
    }
  };

  return (
    <>
      <ChatContainer>
        {messages.map((message, index) => (
          <ChatBubble key={index} message={message} />
        ))}
      </ChatContainer>
      <InputContainer onSubmit={handleSubmit}>
        <Input
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Skriv din melding her..."
        />
        <SendButton type="submit">Send</SendButton>
      </InputContainer>
    </>
  );
}

export default ChatView; 